import React from "react";
import { useAppContext } from "../shared/AppContext";
import useEmailTemplatesController from "./hooks/useEmailTemplatesController";
import EmailTemplatesView from "./components/EmailTemplatesView";

export default function EmailTemplates() {
    const app = useAppContext();
    const ctrl = useEmailTemplatesController();

    if (!app.UserIsSuper) {
        return (
            <div className="container-fluid" style={{ padding: '20px' }}>
                <h4>Access Denied</h4>
                <p>You do not have permission to view this page.</p>
            </div>
        );
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12" style={{ marginTop: '10px', paddingLeft: '0px', paddingRight: '0px' }}>
                    <div className="grantVisualizationCanvas">
                        <div className="grantVisualizationPanelTop">
                            <EmailTemplatesView
                                templates={ctrl.templates}
                                treeNodes={ctrl.treeNodes}
                                loading={ctrl.loading}
                                selectedTemplateName={ctrl.selectedTemplateName}
                                dialogVisible={ctrl.dialogVisible}
                                viewMode={ctrl.viewMode}
                                onViewModeChange={ctrl.setViewMode}
                                onRowClick={ctrl.handleRowClick}
                                onDialogHiding={ctrl.handleDialogHiding}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
